/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from "./routes/__root";
import { Route as LoginImport } from "./routes/login";
import { Route as AppRouteImport } from "./routes/_app/route";
import { Route as IndexImport } from "./routes/index";
import { Route as AppFermentationlabchartsImport } from "./routes/_app/fermentation_lab_charts";
import { Route as AppFlaIndexImport } from "./routes/_app/fla/index";
import { Route as AppFlaSamplesImport } from "./routes/_app/fla/samples";
import { Route as AppFlaPlaygroundImport } from "./routes/_app/fla/playground";
import { Route as AppFlaBatchesIndexImport } from "./routes/_app/fla/batches/index";
import { Route as AppFlaBatchesBatchIdImport } from "./routes/_app/fla/batches/$batchId";

// Create/Update Routes

const LoginRoute = LoginImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRoute,
} as any);

const AppRouteRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRoute,
} as any);

const IndexRoute = IndexImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRoute,
} as any);

const AppFermentationlabchartsRoute = AppFermentationlabchartsImport.update({
  id: "/fermentation_lab_charts",
  path: "/fermentation_lab_charts",
  getParentRoute: () => AppRouteRoute,
} as any);

const AppFlaIndexRoute = AppFlaIndexImport.update({
  id: "/fla/",
  path: "/fla/",
  getParentRoute: () => AppRouteRoute,
} as any);

const AppFlaSamplesRoute = AppFlaSamplesImport.update({
  id: "/fla/samples",
  path: "/fla/samples",
  getParentRoute: () => AppRouteRoute,
} as any);

const AppFlaPlaygroundRoute = AppFlaPlaygroundImport.update({
  id: "/fla/playground",
  path: "/fla/playground",
  getParentRoute: () => AppRouteRoute,
} as any);

const AppFlaBatchesIndexRoute = AppFlaBatchesIndexImport.update({
  id: "/fla/batches/",
  path: "/fla/batches/",
  getParentRoute: () => AppRouteRoute,
} as any);

const AppFlaBatchesBatchIdRoute = AppFlaBatchesBatchIdImport.update({
  id: "/fla/batches/$batchId",
  path: "/fla/batches/$batchId",
  getParentRoute: () => AppRouteRoute,
} as any);

// Populate the FileRoutesByPath interface

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexImport;
      parentRoute: typeof rootRoute;
    };
    "/_app": {
      id: "/_app";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof AppRouteImport;
      parentRoute: typeof rootRoute;
    };
    "/login": {
      id: "/login";
      path: "/login";
      fullPath: "/login";
      preLoaderRoute: typeof LoginImport;
      parentRoute: typeof rootRoute;
    };
    "/_app/fermentation_lab_charts": {
      id: "/_app/fermentation_lab_charts";
      path: "/fermentation_lab_charts";
      fullPath: "/fermentation_lab_charts";
      preLoaderRoute: typeof AppFermentationlabchartsImport;
      parentRoute: typeof AppRouteImport;
    };
    "/_app/fla/playground": {
      id: "/_app/fla/playground";
      path: "/fla/playground";
      fullPath: "/fla/playground";
      preLoaderRoute: typeof AppFlaPlaygroundImport;
      parentRoute: typeof AppRouteImport;
    };
    "/_app/fla/samples": {
      id: "/_app/fla/samples";
      path: "/fla/samples";
      fullPath: "/fla/samples";
      preLoaderRoute: typeof AppFlaSamplesImport;
      parentRoute: typeof AppRouteImport;
    };
    "/_app/fla/": {
      id: "/_app/fla/";
      path: "/fla";
      fullPath: "/fla";
      preLoaderRoute: typeof AppFlaIndexImport;
      parentRoute: typeof AppRouteImport;
    };
    "/_app/fla/batches/$batchId": {
      id: "/_app/fla/batches/$batchId";
      path: "/fla/batches/$batchId";
      fullPath: "/fla/batches/$batchId";
      preLoaderRoute: typeof AppFlaBatchesBatchIdImport;
      parentRoute: typeof AppRouteImport;
    };
    "/_app/fla/batches/": {
      id: "/_app/fla/batches/";
      path: "/fla/batches";
      fullPath: "/fla/batches";
      preLoaderRoute: typeof AppFlaBatchesIndexImport;
      parentRoute: typeof AppRouteImport;
    };
  }
}

// Create and export the route tree

interface AppRouteRouteChildren {
  AppFermentationlabchartsRoute: typeof AppFermentationlabchartsRoute;
  AppFlaPlaygroundRoute: typeof AppFlaPlaygroundRoute;
  AppFlaSamplesRoute: typeof AppFlaSamplesRoute;
  AppFlaIndexRoute: typeof AppFlaIndexRoute;
  AppFlaBatchesBatchIdRoute: typeof AppFlaBatchesBatchIdRoute;
  AppFlaBatchesIndexRoute: typeof AppFlaBatchesIndexRoute;
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppFermentationlabchartsRoute: AppFermentationlabchartsRoute,
  AppFlaPlaygroundRoute: AppFlaPlaygroundRoute,
  AppFlaSamplesRoute: AppFlaSamplesRoute,
  AppFlaIndexRoute: AppFlaIndexRoute,
  AppFlaBatchesBatchIdRoute: AppFlaBatchesBatchIdRoute,
  AppFlaBatchesIndexRoute: AppFlaBatchesIndexRoute,
};

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "": typeof AppRouteRouteWithChildren;
  "/login": typeof LoginRoute;
  "/fermentation_lab_charts": typeof AppFermentationlabchartsRoute;
  "/fla/playground": typeof AppFlaPlaygroundRoute;
  "/fla/samples": typeof AppFlaSamplesRoute;
  "/fla": typeof AppFlaIndexRoute;
  "/fla/batches/$batchId": typeof AppFlaBatchesBatchIdRoute;
  "/fla/batches": typeof AppFlaBatchesIndexRoute;
}

export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "": typeof AppRouteRouteWithChildren;
  "/login": typeof LoginRoute;
  "/fermentation_lab_charts": typeof AppFermentationlabchartsRoute;
  "/fla/playground": typeof AppFlaPlaygroundRoute;
  "/fla/samples": typeof AppFlaSamplesRoute;
  "/fla": typeof AppFlaIndexRoute;
  "/fla/batches/$batchId": typeof AppFlaBatchesBatchIdRoute;
  "/fla/batches": typeof AppFlaBatchesIndexRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  "/": typeof IndexRoute;
  "/_app": typeof AppRouteRouteWithChildren;
  "/login": typeof LoginRoute;
  "/_app/fermentation_lab_charts": typeof AppFermentationlabchartsRoute;
  "/_app/fla/playground": typeof AppFlaPlaygroundRoute;
  "/_app/fla/samples": typeof AppFlaSamplesRoute;
  "/_app/fla/": typeof AppFlaIndexRoute;
  "/_app/fla/batches/$batchId": typeof AppFlaBatchesBatchIdRoute;
  "/_app/fla/batches/": typeof AppFlaBatchesIndexRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | ""
    | "/login"
    | "/fermentation_lab_charts"
    | "/fla/playground"
    | "/fla/samples"
    | "/fla"
    | "/fla/batches/$batchId"
    | "/fla/batches";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | ""
    | "/login"
    | "/fermentation_lab_charts"
    | "/fla/playground"
    | "/fla/samples"
    | "/fla"
    | "/fla/batches/$batchId"
    | "/fla/batches";
  id:
    | "__root__"
    | "/"
    | "/_app"
    | "/login"
    | "/_app/fermentation_lab_charts"
    | "/_app/fla/playground"
    | "/_app/fla/samples"
    | "/_app/fla/"
    | "/_app/fla/batches/$batchId"
    | "/_app/fla/batches/";
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AppRouteRoute: typeof AppRouteRouteWithChildren;
  LoginRoute: typeof LoginRoute;
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  LoginRoute: LoginRoute,
};

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_app",
        "/login"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_app": {
      "filePath": "_app/route.tsx",
      "children": [
        "/_app/fermentation_lab_charts",
        "/_app/fla/playground",
        "/_app/fla/samples",
        "/_app/fla/",
        "/_app/fla/batches/$batchId",
        "/_app/fla/batches/"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/_app/fermentation_lab_charts": {
      "filePath": "_app/fermentation_lab_charts.tsx",
      "parent": "/_app"
    },
    "/_app/fla/playground": {
      "filePath": "_app/fla/playground.tsx",
      "parent": "/_app"
    },
    "/_app/fla/samples": {
      "filePath": "_app/fla/samples.tsx",
      "parent": "/_app"
    },
    "/_app/fla/": {
      "filePath": "_app/fla/index.tsx",
      "parent": "/_app"
    },
    "/_app/fla/batches/$batchId": {
      "filePath": "_app/fla/batches/$batchId.tsx",
      "parent": "/_app"
    },
    "/_app/fla/batches/": {
      "filePath": "_app/fla/batches/index.tsx",
      "parent": "/_app"
    }
  }
}
ROUTE_MANIFEST_END */
